import { api } from '../configs/axiosConfigs';

export const dismissPendingListSortShares = () => {
  return api.post('/list-sorts/dismiss-pending-shares');
};

export const showPendingListSortShares = () => {
  return api.delete('/list-sorts/dismiss-pending-shares');
};
